import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import type { FosfatagemResult } from '../../../recommendations/types';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { mapFosfatagemResponse, type AdubacaoResponse } from './fosfatagemResponse';

export interface AdubacaoProductPayload {
	productId: string;
	dose: number;
}

export interface CalcularAdubacaoPayload {
	adviceId: string;
	products: AdubacaoProductPayload[];
	forma: 'sulco' | 'cova';
	formaConfig: { p: number; l: number; c?: number };
}

export function usePostAdviceCorrectionFosfatagem() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<FosfatagemResult, Error, CalcularAdubacaoPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<AdubacaoResponse>(
					'/advices/planting/calcularAdubacao',
					payload,
					{ params: { forBinding } }
				);
				return mapFosfatagemResponse(data);
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular fosfatagem');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['correction', 'fosfatagem'] }),
		onError: (error) =>
			console.error(
				'Erro ao calcular fosfatagem:',
				getApiErrorMessage(error, 'Erro ao calcular fosfatagem')
			),
	});
}
